import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';

const RadioInput = ({ input, meta, options, }) => {
  const styles = useStyles();
  const error = (meta.error || meta.submitError) && meta.touched

  return (
    <>
      {options.map(({ label, value, }) => (
        <label
          key={value}
          className={styles.label}
          onClick={() => input.onChange(value)}
        >
          <div className={`${styles.circleWrapper} ${input.value === value ? styles.checked : ''}`} />
          <div style={{ color: error ? '#DD0000' : '', }}>
            {label}
          </div>
        </label>
      ))}
    </>
  );
};

const useStyles = createUseStyles({
  label: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    fontSize: '16px',
    color: '#444F57',
    fontWeight: 'normal',
  },
  circleWrapper: {
    width: 27,
    height: 27,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '15px',
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: '#BEBEBE',
    borderRadius: 15,
    transition: 'all 0.2s',
  },
  checked: {
    borderColor: '#3D93E8',
    borderWidth: '9px',
  },
  circle: {
    width: 8,
    height: 8,
    backgroundColor: '#57c2ef',
    borderRadius: 8,
  },
});

RadioInput.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    value: PropTypes.string,
  })).isRequired,
};

export default RadioInput;
